import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { IBreastCancerPRS, IFetchBreastCancerPRSParams } from '~/interfaces'
import { HttpStatusCode, NotFoundError, UnexpectedError } from '~/protocols/http'
import { fetchBreastCancerPRS, message } from '~/services'
import { hasObjectValue } from '~/utils'

const UNIQUE_KEY = 'breastCancerPrs'

type ErrorType = NotFoundError | UnexpectedError

export const useFetchBreastCancerPRS = (
  fetchParams: IFetchBreastCancerPRSParams | null
): UseQueryResult<IBreastCancerPRS, ErrorType> => {
  const hasFetchParams = hasObjectValue({ ...fetchParams })

  const fetcher = async () => {
    if (!fetchParams) throw new Error('fetchParams is required')

    try {
      const response = await fetchBreastCancerPRS(fetchParams)

      return response
    } catch (error: any) {
      if (error?.status === HttpStatusCode.notFound)
        throw new NotFoundError(message('analyticalModels.breast_cancer_prs_not_found'))

      throw new UnexpectedError(message('messages.genericUnexpectedError'))
    }
  }

  return useQuery<IBreastCancerPRS, ErrorType>([UNIQUE_KEY, fetchParams], fetcher, {
    enabled: hasFetchParams,
    cacheTime: Infinity,
    staleTime: Infinity
  })
}
